// @flow

import React, {useState} from "react";
import {Form, Button, Row, Input, Select, InputNumber, Modal} from "antd";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../../hooks/useStore";
import moment from "moment";

export const SelectJokerModal = ({
    courierId,
    courierFullname,
    poolId,
    date,
    recall = () => {},
    dateOptions = [],
    visibility,
    onChangeVisibility = () => {}
}) => {
    const stores = useStore();
    const [startHourId, setStartHourId] = useState(undefined);
    const [endHourId, setEndHourId] = useState(undefined);
    const [jokerDistance, setJokerDistance] = useState(1000);
    const [submitting, setSubmitting] = useState(false);
    const {t} = useTranslation();
    const submitForm = async () => {
        setSubmitting(true);
        try {
            const params = {courierId, poolId, date, startHourId, endHourId, jokerDistance};
            await stores.poolShiftStore.setJokerCourierForShift(params);
            setSubmitting(false);
            resetForm();
            recall();
            onChangeVisibility();
        } catch (error) {
            setSubmitting(false);
            let errorMessage =
                error?.message ||
                t("errorMessages.AnUnknownErrorWasOccurred", {
                    ns: "common"
                });
            if (error?.errors?.length > 0) {
                errorMessage = error.errors.join("\n");
            }
            stores.appStore.openErrorModal({content: errorMessage});
        }
    };

    const resetForm = () => {
        setStartHourId(undefined);
        setEndHourId(undefined);
        setJokerDistance(1000);
    };

    const renderForm = () => {
        return (
            <Row>
                <Form autoComplete="off" style={{width: "100%"}}>
                    <Form.Item colon={false}>
                        <h5>Kurye Adı</h5>
                        <Input name="fullname" value={courierFullname} disabled />
                    </Form.Item>
                    <Form.Item colon={false}>
                        <h5>Tarih</h5>
                        <Input
                            name="date"
                            value={date ? moment(date).format("DD.MM.YYYY") : ""}
                            disabled
                        />
                    </Form.Item>
                    <Form.Item>
                        <h5>Başlangıç Saati</h5>
                        <Select
                            showSearch
                            name="startHourId"
                            value={startHourId}
                            onChange={value => {
                                setStartHourId(value);
                                setEndHourId(undefined);
                            }}
                        >
                            {dateOptions
                                .filter((d, i) => {
                                    const optionDate = moment(
                                        `${d?.date} ${d?.hour?.endTime}`,
                                        "YYYY-MM-DD HH:mm"
                                    ).toDate();
                                    const now = moment();
                                    const lateHours = ["23:30"];
                                    return (
                                        now.isSameOrBefore(moment(optionDate)) ||
                                        (i !== 0 && lateHours.includes(d?.hour?.startTime))
                                    );
                                })
                                .map((d, i) => (
                                    <Select.Option key={i} value={d?.hour?._id?.toString()}>
                                        {d?.hour?.startTime}
                                    </Select.Option>
                                ))}
                        </Select>
                    </Form.Item>
                    <Form.Item>
                        <h5>Bitiş Saati</h5>
                        <Select
                            showSearch
                            name="endHourId"
                            value={endHourId}
                            onChange={value => setEndHourId(value)}
                            disabled={!startHourId}
                        >
                            {dateOptions
                                .filter((d, i) => {
                                    const shiftStartIndex = dateOptions.findIndex(
                                        d => d?.hour?._id?.toString() === startHourId
                                    );
                                    return i >= shiftStartIndex;
                                })
                                .map((d, i) => (
                                    <Select.Option key={i} value={d?.hour?._id?.toString()}>
                                        {d?.hour?.endTime}
                                    </Select.Option>
                                ))}
                        </Select>
                    </Form.Item>
                    <Form.Item colon={false}>
                        <h5>Mesafe</h5>
                        <InputNumber
                            name="jokerDistance"
                            value={jokerDistance}
                            onChange={setJokerDistance}
                        />
                    </Form.Item>
                </Form>
            </Row>
        );
    };

    return (
        <Modal
            zIndex={1000}
            title={"Joker Tanımlaması Yap"}
            visible={visibility}
            onCancel={() => {
                resetForm();
                onChangeVisibility();
            }}
            onOk={submitForm}
            confirmLoading={submitting}
            okText={t("modal.sendButton", {ns: "common"})}
            cancelText={t("modal.cancelButton2", {ns: "common"})}
        >
            {renderForm()}
        </Modal>
    );
};
